/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ProductCategoryType = {
    DECORATION: 'DECORATION',
    SERVICE: 'SERVICE',
    FAVOURITE: 'FAVOURITE',
    STANDART: 'STANDART',
    NEW_FORMAT: 'NEW_FORMAT'
} as const;
export type ProductCategoryType = typeof ProductCategoryType[keyof typeof ProductCategoryType];

